module.exports = __webpack_public_path__ + "assets/01c5b2b37e96d9265f5ae45295f0a31c.mp3";